import React from "react";

import useTheme from "hooks/useTheme";

import AlammexIcon from "theme/icons/Alammex";
import AlgoExplorerIcon from "theme/icons/AlgoExplorer";
import SendIcon from "theme/icons/Send";
import VestigeIcon from "theme/icons/Vestige";

const BalancesLoader = () => {
	const { themeColor } = useTheme();

	return (
		<div className="flex w-full items-center justify-between animate-pulse">
			<div className="flex items-center space-x-2">
				<div className={`rounded-full ${themeColor?.bg} h-8 w-8 mt-1`}></div>

				<div className="flex-col flex px-5">
					<div className="flex-1 space-y-6 py-1">
						<div className={`h-2 ${themeColor?.bg} rounded`}></div>
					</div>

					<div className="flex w-full text-right justify-end space-x-1">
						<div className="flex-1 space-y-6 py-1">
							<div className="space-y-3">
								<div className="grid grid-cols-3 gap-4">
									<div className={`h-2 ${themeColor?.bg} rounded col-span-2`}></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="flex w-fit items-center justify-end">
				<div className="flex flex-col px-5 items-center justify-end">
					<div className="flex-col flex px-5">
						<div className="flex-1 space-y-6 py-1">
							<div className={`h-2 ${themeColor?.bg} rounded`}></div>
						</div>

						<div className="flex w-full text-right justify-end space-x-1">
							<div className="flex-1 space-y-6 py-1">
								<div className="grid grid-cols-3 gap-4">
									<div className={`h-2 ${themeColor?.bg} rounded col-span-2`}></div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="flex w-fit items-center justify-end space-x-3 px-5">
					<SendIcon className="w-5" fill={themeColor?.hex} />
					<AlammexIcon className="w-5" fill={themeColor?.hex} />
				</div>
			</div>
		</div>
	);
};

export default BalancesLoader;
